/* Core & libraries */
import React, { useState, useRef, useEffect } from "react";
import { useTheme } from "react-jss";
import {defineMessages, FormattedMessage, useIntl} from "react-intl";
import {ErrorMessage, Field, Formik, getIn} from "formik";
import ContainerFluid from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import UCButton from "../../buttons";

/* Helpers, constants, custom methods, internal libraries */
import {
  createValidationPolicyYupSchema,
  useValidationService
} from "../../../resources/validations/validations";
import { colors } from "../../../constants/colors";
import { useHasPermission } from "../../../hooks/useHasPermission";

/* Components */
import { ReactComponent as DeleteSvg } from '../../../resources/images/trash-edit-team.svg';

/* Styles */
import styles from "./styles.js"

const Content = props => {
  const { setShowModal, handleSubmit, setShowDeleteModal, companyEntityId, label, successCallback } = props;

  const theme = useTheme();
  const classes = styles({ theme });

  const { checkPermission } = useHasPermission();

  const formRef = useRef(null);
  const intl = useIntl();

  const { editLabelMockedValidationObj } = useValidationService()
  const [testSchema, setTestSchema] = useState({});

  useEffect(() => {
    //TODO: api call to get validations //simpleMockedApiValidationObj
    const result = createValidationPolicyYupSchema(editLabelMockedValidationObj);
    setTestSchema(result)
  }, [])

  const handleFormSubmit = () => {
    if (formRef.current) {
      formRef.current.handleSubmit()
    }
  }

  const submitForm = async (values, setErrors) => {
    const payload = {
      labelId: label.labelId,
      label: values.name,
      companyEntityId: companyEntityId,
    }
    const response = await handleSubmit(payload);
  
    if (response?.errorMessages && response?.errorMessages[0]?.code === "12002") {
      const error = <FormattedMessage id={"editLabelValidation.nameAlreadyExist"} />
      setErrors({name: error})
    } else if (response) {
      successCallback(response.label);
      setShowModal(false);
    }
  }

  const handleDelete = () => {
    setShowModal(false)
    setShowDeleteModal(true)
  }

  const nameChange = (e, handleChange, setFieldValue) => {
    const value = e.target.value;
    handleChange(e);
    setFieldValue("name", value);
  };

  return (
    <div className={classes.modalContent}>
      <Formik
        innerRef={formRef}
        initialValues={{
          name: label?.label
        }}
        validationSchema={testSchema}
        onSubmit={(values, { setErrors }) => {
          submitForm(values, setErrors);
        }}
      >
        {({
          values,
          errors,
          touched,
          setFieldTouched,
          handleChange,
          handleBlur,
          handleSubmit,
          isSubmitting,
          setFieldValue,
          setErrors
          }) => (

          <>
            <form onSubmit={handleSubmit} >
              <div className={classes.inputContainer}>
                <label htmlFor="name" className={classes.label}>
                  <FormattedMessage id="editLabel.name"/>
                </label>
                <Field
                  placeholder={intl.formatMessage({id: "editLabel.namePlaceholder"})}
                  type="name"
                  name="name"
                  id="name"
                  autoComplete="off"
                  onChange={(e) =>
                    nameChange(e, handleChange, setFieldValue)
                  }
                  className={
                    (errors.name && touched.name)
                      ? "input-error"
                      : null
                  }
                />
                <ErrorMessage
                  name="name"
                  component="span"
                  className={classes.error}
                />
              </div>
              <div className={classes.btnContainer}>
                <ContainerFluid>
                  <Row>
                    <Col className={classes.colCancel}>
                      <UCButton
                        onClick={() => setShowModal(false)}
                        type="default"
                        className={classes.cancelBtn}
                        text={<FormattedMessage id="editLabel.cancel"/>}
                      />
                    </Col>
                    <Col className={classes.colRemove} >
                      <UCButton
                        className={classes.createBtn}
                        onClick={handleFormSubmit}
                        type="primary"
                        text={<FormattedMessage id="editLabel.update"/>}
                        spinner={{
                          name: "editLabelSpinner",
                          size: 20,
                        }}
                      />
                    </Col>
                  </Row>
                </ContainerFluid>
              </div>
            </form>
          </>
        )}
      </Formik>
      <div className={classes.dividerContainer}>
        <hr className={classes.border}/>
      </div>
      <div className={classes.deleteContainer}>
        {
          checkPermission("F_GUEST_PROFILE_MANAGE") &&
            <UCButton
              className={classes.deleteBtn}
              onClick={() => handleDelete()}
              type="default"
              text={
                <div className={classes.deleteText}>
                  <DeleteSvg />
                  <FormattedMessage id="editLabel.delete"/>
                </div>
              }
            />
        }

      </div>
    </div>
  )
}

export default Content;
